const acArticles = [
  {
    title: "Alexander Fan, CC ’25, on cheerleading for the Philadelphia Eagles",
    author: "Beatrice Moyers",
    articleLink: "https://www.columbiaspectator.com/arts-and-culture/2025/10/14/alexander-fan-cc-25-on-cheerleading-for-the-philadelphia-eagles/",
    image: "https://www.columbiaspectator.com/resizer/v2/36Z37AVHYRFCBB75JN2U3EAOFQ.jpeg?auth=d1a45c8d9b2932291618cc96930ebc0d7aeab30324f9e959edf367532f2cc11e"
  },
  {
    title: "Do Homecoming expectations meet reality? Columbia students weigh in on media’s influence on school spirit",
    author: "Taylor Graham",
    articleLink: "https://www.columbiaspectator.com/arts-and-culture/2025/10/15/do-homecoming-expectations-meet-reality-columbia-students-weigh-in-on-medias-influence-on-school-spirit/",
    image: "https://www.columbiaspectator.com/resizer/v2/52565ANVFNAV5DPOCQYM5NYQ24.PNG?auth=236ed2c6e97e7b6def36dcc9da7da17c632299c1353afba06765b68be35f9c15"
  }
];
export default acArticles;